export default __webpack_public_path__ + "static/media/white_modal_close.98783fa4.svg";